(ns rothko.editor.word.paths
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.paths :as paths]))

(defn word?
  ([index]
   (word? index index))
  ([start-index end-index]
   [:script
    (paths/safe-nthpath
     start-index
     [:type
      (sp/pred= :word)])]))

(defn edited?
  [index]
  [:script
   (paths/safe-nthpath
    index
    [(sp/must :edited?)])])
